import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=ba6925d4&scoped=true"
import script from "./LayoutAuth.vue?vue&type=script&lang=js"
export * from "./LayoutAuth.vue?vue&type=script&lang=js"
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=ba6925d4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6925d4",
  null
  
)

export default component.exports